import { moment } from 'locale'
import type { Moment } from 'moment'

const momentParserFormats = ['L', 'DD.MM.YYYY', 'MM/DD/YYYY', moment.ISO_8601]

export const momentValidDateFormat = 'YYYY-MM-DD'

export const getDateForRequest = (date?: Date | string | null) => {
  if (!date) {
    // most likely it's undefined
    return date
  }

  return moment.utc(date, momentParserFormats).toISOString()
}

export const getMomentDate = (date?: Moment | Date | string | number) => {
  if (!date) {
    return moment()
  }

  if (typeof date === 'number') date = moment(date).format(momentValidDateFormat)

  return moment.utc(date, momentParserFormats)
}

const MIN_TICK = 5

export function getMinTick(time: string) {
  let minutes: string | number = +time.slice(3, 5) || 0
  const hour = time.slice(0, 2) || '00'

  while (minutes % MIN_TICK !== 0) minutes--
  minutes = `${minutes}`.padStart(2, '0')

  return `${hour}:${minutes}:00`
}

export function parseDateForRequest(date: Moment | string, addTime = false) {
  const time = moment().format('HH:mm:00')
  const tickTime = getMinTick(time)
  const utcDate = moment.utc(date)

  return addTime ? `${utcDate.format(momentValidDateFormat)}T${tickTime}` : utcDate.format(momentValidDateFormat)
}

export const isBeforeNoonAtAppStart = moment().isBefore(moment('12:00:00', 'hh:mm:ss'))

export function formatTime(datetime?: string | null) {
  return datetime ? moment(datetime).format('HH:mm') : ''
}

export function formatDate(datetime?: string | null) {
  return datetime ? moment(datetime).format('L') : ''
}
